const countdownFn = (root, storybookRoot) => {

  let startDate, startDateTarget = root.dataset.mdnStartDateTarget;

  if (startDateTarget) {
    startDate = document.querySelector(startDateTarget).dataset.mdnStartDate
  } else {
    startDate = root.dataset.mdnStartDate
  }

  startDate = parseInt(startDate);

  if (isNaN(startDate)) {
    startDate = Date.now();
  }

  const endDate = parseInt(root.dataset.mdnEndDate);
  const rangeDate = endDate - startDate;
  const second = 1000;
  const timers = root.querySelectorAll(".mdn-Countdown-timer,.mdn-Countdown-bar-progress-value");
  const progressBar = root.querySelector(".mdn-Countdown-bar-progress");
  const shouldHideTimeInDays = root.dataset.mdnShowOnlyHours === "true";
  const shouldSplitTime = root.dataset.mdnSplitTime === "true";
  let hideOnEnd = root.dataset.mdnHideOnEndId;
  const willHideOnEnd = root.dataset.mdnHideOnEnd === "true";
  const willRemoveOnEnd = root.dataset.mdnRemoveOnEnd === "true";
  let deleteOnEnd = root.dataset.mdnDeleteOnEndId;
  let currentDate = startDate, days, hours, minutes, seconds, text, diffTime;
  const countdownInterval = window.setInterval(update, second);
  let countdownMinimizeTimeout;
  const alwaysOpen = root.dataset.mdnAlwaysOpen === "true";
  let isBlock = false;  

  if (root.classList.contains("mdn-Countdown--block")) {
    isBlock = true;
    startMinimizeTimeOut;
    root.onmouseenter = stopMinimizeTimeOut
    root.onmouseleave = startMinimizeTimeOut
  }

  function minimize() {
    root.classList.remove('mdn-isOpen')
    root.querySelector(".mdn-Countdown-container").classList.remove("mdn-Container")
  }

  function stopMinimizeTimeOut() {
    root.classList.add('mdn-isOpen')
    const mdnCountDown = root.querySelector(".mdn-Countdown-container");
    mdnCountDown && mdnCountDown.classList.add("mdn-Container")
    window.clearTimeout(countdownMinimizeTimeout);
  }

  function startMinimizeTimeOut() {
    countdownMinimizeTimeout = !alwaysOpen ? window.setTimeout(minimize, second * 5) : null;

  }

  function update() {
    
    diffTime = (endDate - currentDate);

    if (diffTime <= 0) { // if over
      diffTime = 0
      clearInterval(countdownInterval);

      // Fazer elemento sumir
      hideOnEnd = document.getElementById(hideOnEnd)
      deleteOnEnd = document.getElementById(deleteOnEnd)
      if (willHideOnEnd) {
        root.style.display = 'none';
      }
      if (hideOnEnd) {
        hideOnEnd.style.display = 'none';
      }
      if (willRemoveOnEnd) {
        root.parentElement.removeChild(root);
      }
      if (deleteOnEnd) {
        deleteOnEnd.parentElement.removeChild(deleteOnEnd)
      }
      root.onend && root.onend(root)
    }

    days = parseInt((diffTime) / (1000 * 60 * 60 * 24));
    hours = Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    minutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));
    seconds = Math.floor((diffTime % (1000 * 60)) / 1000);

    hours = hours < 10 ? ("0" + hours) : hours;
    minutes = minutes < 10 ? ("0" + minutes) : minutes;
    seconds = seconds < 10 ? ("0" + seconds) : seconds;

    if (shouldHideTimeInDays) {
      hours = Number(hours) + Number(days) * 24;
      days = 0;
    }

    if (days === 0) {
      text = !shouldSplitTime ? `${hours}:${minutes}:${seconds}` : `<span class="mdn-Countdown-timer-hours">${hours}</span><span class="mdn-Countdown-timer-splitter">:</span><span class="mdn-Countdown-timer-minutes">${minutes}</span><span class="mdn-Countdown-timer-splitter">:</span><span class="mdn-Countdown-timer-seconds">${seconds}</span>`;
    } else {
      text = (days === 1) ? `${days} dia` : `${days} dias`;
    }

    currentDate += second;

    if (isBlock) {
      let width = 100 - 100 * (Math.max(0, endDate - currentDate)) / rangeDate
      progressBar.style.width = `${width}%`;
      timers[0][shouldSplitTime ? 'innerHTML' : 'innerText'] = text;
      if (width < 90) {
        timers[1].innerText = text;
        progressBar.innerText = '';
      } else {
        timers[1].innerText = '';
        progressBar.innerText = text;
      }
    } else {
      timers[0][shouldSplitTime ? 'innerHTML' : 'innerText'] = text;
    }


  }

  //============
  // Extra methods
  //============

  root.getCurrentDiffTime = function () {
    return diffTime
  }

  root.getendDate = function () {
    return endDate
  }

  root.getState = function () {
    return diffTime <= 0 ? 'end' : 'running';
  }

  root.onend = root.onend || null;

  return storybookRoot ? storybookRoot : root
}

export default countdownFn;
